import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { actions } from '../features/member-profile-slice';
import { readProfile, updateProfile } from '../features/member-profile-thunk';

import { ZetaSection, ZetaGroup } from '../zeta-widget';
import { useZetaDispatchChange } from '../zeta-widget/tools/handle-tool'

const tplProfile = require('../templates/member-profile-edit.json');

export function MemberProfilePage(props) {
  const data = useSelector((state) => state.memberProfile.data);

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(readProfile());
  },[dispatch]);

  const handleChange = useZetaDispatchChange(data, dispatch, actions.setData);

  const handleActionClick = useCallback((e) => {
    switch(e.target.name) {
      case 'btnBack':
        history.goBack();
        return;

      case 'btnSave':
        dispatch(updateProfile(data));
        history.push('/member/home');
        return;
  
      default:
        break;
    }      
  }, [data, dispatch, history]);

  const handlers = {
    handleActionClick
  };

  const _this = {
    // activeSection,
    handlers,
  };

  return (
    <>
      <ZetaSection name="entry" title="แก้ไขข้อมูลสมาชิก" app={_this}>
        <ZetaGroup size="medium" template={tplProfile} data={data} app={_this} onChange={handleChange} />
      </ZetaSection>
    </>
  );

}